import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  inputSection: {
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'center',
    color: theme.palette.textAlt,
    margin: '0.5rem 0',

    '& label': {
      display: 'inline-block',
      width: '11rem'
    },

    '& input': {
      marginLeft: '0.125rem',
      border: 'none',
      outline: 'none',
      margin: '5px 0px',
      width: 300
    }
  },
  multiLineSection: {
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'center',
    color: theme.palette.textAlt,
    margin: '0.5rem 0',

    '& label': {
      display: 'inline-block',
      width: '11rem',
      alignSelf: 'baseline',
      marginTop: '0.5rem'
    },

    '& textarea': {
      marginLeft: '0.125rem',
      border: 'none',
      outline: 'none',
      margin: '5px 0px',
      width: 300,
      resize: 'none'
    }
  }
}))

export default useStyles
